var _path, _path2, _g, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConclusionNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 242,
    viewBox: "0 0 296 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19569_43571)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.139 39.2779C135.616 27.1646 95.0476 -11.4798 55.2847 3.94341C15.5217 19.3667 5.41705 47.3885 1.29049 93.3717C-2.83606 139.355 42.8254 200.055 66.6868 209.179C125.787 231.78 138.746 257.957 172.057 227.576C209.526 193.403 201.394 188.636 232.431 158.155C252.316 138.626 292.305 128.498 293.172 105.819C294.039 83.1402 299.227 37.525 263.981 21.2973C228.734 5.06955 213.682 57.1629 167.139 39.2779Z",
    fill: "#00C6C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19569_43571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 294,
    height: 242
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.072 39.3369C136.543 27.2934 96.0122 -11.2336 56.1802 4.24099C16.3481 19.7156 6.17781 47.7216 1.95553 93.6569C-2.26676 139.592 43.3176 200.139 67.1838 209.211C126.296 231.681 139.215 257.804 172.619 227.401C210.192 193.203 202.062 188.456 233.189 157.957C253.133 138.416 293.181 128.231 294.094 105.577C295.007 82.924 300.291 37.3543 265.043 21.2078C229.795 5.06137 214.624 57.1188 168.072 39.3369Z",
    fill: "#00C6C6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19569_43571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.899 177.664C163.861 203.112 181.565 243.004 147.486 245.012C110.053 247.219 60.0853 261.426 38.2252 230.625C14.2942 196.906 60.8446 152.817 53.4487 112.513C47.6119 80.7053 -0.571482 64.3115 1.82307 32.2513C4.1875 0.594319 33.4406 -28.4619 64.5072 -35.5478C94.8639 -42.4718 120.93 -13.1082 150.272 -1.608C167.403 5.10621 238.949 6.06633 256.113 12.6931C269.293 9.26578 278.989 -30.4097 300.462 37.1484C312.828 61.4122 259.168 95.9859 253.779 122.271C247.144 154.627 207.439 152.791 185.899 177.664Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.485 217.166C103.455 181.451 135.399 201.924 155.884 167.454C181.49 124.367 139.9 95.9961 174.595 80.6919C209.29 65.3877 259.888 55.102 261.227 39.0357C262.298 26.1826 251.492 17.8698 251.465 16.2659",
    stroke: "#5B686D",
    strokeWidth: 3,
    strokeDasharray: "16 12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3101 1.55485C82.988 23.6695 87.3349 71.3006 59.299 84.9077C24.2542 101.916 16.8689 68.4424 11.5142 71.0803C7.23041 73.1906 4.25608 80.671 3.30439 84.1474",
    stroke: "#5B686D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "15 12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 131.5,
    width: 153,
    height: 56.3222,
    rx: 4.63333,
    fill: "white",
    stroke: "#C8CDD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8442,
    y: 137.844,
    width: 53.9,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8442,
    y: 154.956,
    width: 46.2,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8442,
    y: 166.933,
    width: 140.311,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8442,
    y: 175.489,
    width: 119.778,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 145.433,
    y: 154.956,
    width: 46.2,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 165.967,
    y: 136.133,
    width: 38.5,
    height: 8.55556,
    rx: 4.27778,
    fill: "#D1D4DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 209.6,
    y: 136.133,
    width: 8.55556,
    height: 8.55556,
    rx: 4.27778,
    fill: "#D1D4DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8442 149.822L218.155 149.822",
    stroke: "#EFF2F7",
    strokeWidth: 0.855556
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 54.5,
    width: 179,
    height: 66,
    rx: 5.5,
    fill: "white",
    stroke: "#C8CDD8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 62,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 82,
    width: 54,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 164,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 106,
    width: 140,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 82,
    width: 54,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 60,
    width: 45,
    height: 10,
    rx: 5,
    fill: "#D1D4DB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 60,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#D1D4DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76L230 76",
    stroke: "#EFF2F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19569_43571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 242,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConclusionNotFound);
export default __webpack_public_path__ + "static/media/conclusion-not-found.60f731b628a797691b4ff6455c7e2cdd.svg";
export { ForwardRef as ReactComponent };